$(function() {
    $(".btn-next-form-section").click(function(e) {
        e.preventDefault();

        const target = $(this).data("section");

        //simulate click on tab nav
        $(".nav-link[aria-controls='" + target + "']").click();

        moveToFormNav();
    });
});

function moveToFormNav() {
    $('html, body').animate({
        scrollTop: 0
    }, 500);
}

